import { render, staticRenderFns } from "./QualityControlDetail.vue?vue&type=template&id=aee88226"
import script from "./QualityControlDetail.vue?vue&type=script&lang=js"
export * from "./QualityControlDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports